import _sortBy from "lodash/sortBy";

import { API, APIResultList, Item } from "@thenounproject/lingo-core";

import { sortSectionItems } from "@redux/actions/sections/sortSectionItems";
import { createAsyncAction } from "../actionCreators";

/**
 * Batch updates an array of item ids with a new status
 * @param {Array} items Array of objects containing item id
 * @param {String} status trashed | deleted | active
 * @param {Array} sectionId Pass the section id if we're deleting items from a section
 * @param {Array} galleryOutline Outline of the gallery items from which the action was called
 */
type Args = {
  items: string[];
  status: Item["status"];
};

const [useBatchUpdateItemStatus, batchUpdateItemStatus] = createAsyncAction(
  "items/batchUpdateItemStatus",
  async ({ items, status }: Args, thunkApi) => {
    /**
     * Basic updates from the status update
     */
    const itemData = items.map(id => {
      return { uuid: id, status };
    });

    const res = await API.call<APIResultList<"items", string>>({
      endpoint: "sync/items",
      method: "POST",
      data: {
        items: [...itemData],
      },
    });

    // TODO: This probably won't work anymore since the API call has been run
    // but the result hasn't  been passed through the reducer yet.
    // Sort the sections containing any restored items
    if (status !== "active") return res;
    const sectionsWithRestoredItems = (Object.values(res.entities.items) as Item[])
      .filter(i => i.status === "active")
      .map(i => i.sectionId)
      .filter(Boolean);
    if (sectionsWithRestoredItems.length) {
      thunkApi.dispatch(sortSectionItems([...new Set(sectionsWithRestoredItems)]));
    }
    return res;
  }
);
export default useBatchUpdateItemStatus;
export { batchUpdateItemStatus };
